import { useCallback, useState } from 'react'
import { HexColorPicker } from 'react-colorful'
import { Button } from '#app/components/ui/button.js'
import { Input } from '#app/components/ui/input.js'
import { Icon } from '../../ui/Icon'

export type ColorPickerProps = {
	color?: string
	onChange?: (color: string) => void
	onClear?: () => void
}

export const ColorPicker = ({ color, onChange, onClear }: ColorPickerProps) => {
	const [colorInputValue, setColorInputValue] = useState(color || '#ffffff')

	const handleColorChange = useCallback(() => {
		const isCorrectColor = /^#([0-9A-F]{3}){1,2}$/i.test(colorInputValue)

		if (!isCorrectColor) {
			if (onChange) {
				onChange('')
			}

			return
		}

		if (onChange) {
			onChange(colorInputValue)
		}
	}, [colorInputValue, onChange])

	return (
		<div className="flex flex-col gap-1">
			<HexColorPicker
				className="!h-[75px] !w-full rounded-xl"
				color={color === '' ? '#ffffff' : color}
				onChange={color => {
					if (onChange) onChange(color)
					setColorInputValue(color)
				}}
			/>
			<div className="flex gap-1">
				<Input
					type="text"
					className="h-8 w-full px-2"
					placeholder=""
					value={color === '' ? '#ffffff' : color}
					onChange={e => {
						if (onChange) onChange(e.currentTarget.value)
						setColorInputValue(e.currentTarget.value)
					}}
					onBlur={handleColorChange}
				/>
				<Button onClick={onClear} size="s" className="w-8" variant="ghost">
					<Icon name="Undo" className="shrink-0" />
				</Button>
			</div>
		</div>
	)
}
